import Card from '@components/Card';
import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import EditIcon from '@icons/edit/EditFill';
import TrashIcon from '@icons/TrashFill';
import { useAtom, useAtomValue } from 'jotai';

import HandleIcon from './HandleIcon';
import img from './img.png';
import styles from './styles.module.scss';
import { deleteMyMenuIdsAtom, isDeletingAtom } from '../../atoms/myMenuAtoms';

interface Props {
    id: string;
}

function MyMenuItem({ id }:Props) {
  const isDeleting = useAtomValue(isDeletingAtom);
  const [deleteIds, setDeleteIds] = useAtom(deleteMyMenuIdsAtom);
  const isChecked = deleteIds.includes(id);
  const toggleCheckbox = () => {
    if (isChecked) {
      setDeleteIds(deleteIds.filter((deleteId) => deleteId !== id));
    } else {
      setDeleteIds([...deleteIds, id]);
    }
  };
  return (
        <Row spacing={18}>
            {isDeleting && (
                <Checkbox className={styles.checkbox}
                          toggleCheckbox={toggleCheckbox} />
            )}
            <Card className={styles.card}>
                <Card.Body>
                    <Row spacing={4} fullWidth>
                        <Image src={img} alt='myMenu'
                               width={76}
                               height={76} />
                        <Column fullWidth>
                            <Row justify='flex-end' fullWidth className={styles.handle}>
                                <HandleIcon/>
                            </Row>
                            <Text size='xl' fontWeight='bold'>겨울에도 얼죽아 화이팅</Text>
                            <Text color={colors.gray6} className={styles.name} fontWeight='bold'>
                                아이스 아메이카노
                            </Text>
                            <div className={styles.option}>
                                ICEㅣ일회용컵 사용ㅣL사이즈ㅣ샷추가(+500)ㅣ카라멜마끼아또 시럽추가(+500)ㅣ설탕 시럽추가(+500)
                            </div>
                        </Column>
                    </Row>
                </Card.Body>
                <Card.Footer>
                    <Row fullWidth justify='flex-end' spacing={10}>
                        <Row>
                            <EditIcon size={24}/>
                            <Text color={colors.gray7}>이름 변경</Text>
                        </Row>
                        <Row>
                            <TrashIcon size={24}/>
                            <Text color={colors.gray7}>삭제</Text>
                        </Row>
                    </Row>
                </Card.Footer>
            </Card>
        </Row>
  );
}

export default MyMenuItem;
